module.exports = __webpack_public_path__ + "media/images/appIcon-6e665f9aa8f0f53732d16e2f4c0742d7.png";